import { wealthProApi } from "../../redux/api";
import { applyPatch } from "fast-json-patch";
import _ from "lodash";

const serviceTermsApiEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        patchClientServiceLevelAgreement: builder.mutation({
            query: ({
                clientServiceAgreementId,
                masterAccountId,
                operations,
            }) => ({
                url: `api/review/client-sla/${clientServiceAgreementId}`,
                method: "PATCH",
                body: operations,
            }),
            async onQueryStarted(
                { clientServiceAgreementId, masterAccountId, operations },
                { dispatch, queryFulfilled }
            ) {
                try {
                    const { data: clientServiceTerms } = await queryFulfilled;
                    dispatch(
                        wealthProApi.util.updateQueryData(
                            "fetchClientServiceTerms",
                            { masterAccountId },
                            (data) => {
                                // applyPatch(data, operations, true);
                                return clientServiceTerms;
                            }
                        )
                    );
                } catch {
                    //result.undo();
                }
            },
        }), 
        searchClientServiceAgreements: builder.query({
            query: (data) => ({
                url: `api/review/client-sla`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (response, _, { cacheKey }) => {
                return { cacheKey, ...response };
            },
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                // const { cacheKey } = queryArgs || {};
                // return `${endpointName}-${cacheKey}`
                return endpointName;
            },
            merge: (currentCache, newItems) => {
                if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
                    currentCache.pagination = newItems.pagination;
                    currentCache.results.push(...newItems.results);
                }
                else {
                    currentCache.cacheKey = newItems.cacheKey;
                    currentCache.pagination = newItems.pagination;
                    currentCache.results = [...newItems.results];
                }             
            }
        }),
        createClientServiceLevelAgreement: builder.mutation({
            query: ({ masterAccountId }) => ({
                url: `api/review/client-sla/${masterAccountId}`,
                method: "POST",
                body: {},
            }),
            invalidatesTags: ["clientServiceTerms"],
        }),
        renewTerms: builder.mutation({
            query: ({ clientServiceLevelAgreementId, masterAccountId }) => ({
                url: `api/review/client-sla/${clientServiceLevelAgreementId}`,
                method: "PUT",
                body: {},
            }),
            invalidatesTags: ["clientServiceTerms"],
        }),
    }),
});

export const {
    usePatchClientServiceLevelAgreementMutation,
    useLazySearchClientServiceAgreementsQuery,
    useCreateClientServiceLevelAgreementMutation,
    useRenewTermsMutation,
} = serviceTermsApiEndpoints;
